export class HeaderSearch {
    constructor(public bodyElement: any) {
        let headerSearchTrigger = document.getElementById('searchTrigger');
        let headerSearch = document.getElementById('headerSearch');
        let searchActive = false;
        
        let bodySearchHandler = function() {
            if (searchActive === true) {
                showSearch(false);
            }
        }

        function showSearch(isVisible) {
            if (isVisible) {
                headerSearch.classList.add('active');
                headerSearchTrigger.parentElement.classList.add('show-menu');
                searchActive = true;
                bodyElement.addEventListener('click', bodySearchHandler);
            } else {
                headerSearch.classList.remove('active');
                headerSearchTrigger.parentElement.classList.remove('show-menu');
                searchActive = false;
                bodyElement.removeEventListener('click', bodySearchHandler);
            };
        };

        if (headerSearchTrigger) {
            headerSearchTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (searchActive === true) {
                    showSearch(false);
                } else {
                    showSearch(true);
                };
            });

            headerSearch.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/header-search.ts